import { IFaceLoader } from './IFaceLoader';
import { FC, useEffect } from 'react';
import { sanitizeReturnUrl, sanitizeReturnUrlAndRedirect } from '@/ui-kit/utils/sanitizeUrl';
import { Trans } from '@/ui-kit/hooks/useTranslation';
import { Link } from '@mui/material';

export const NavigateToExternalUrl: FC<{ to: string; delay?: number }> = ({ to, delay = 0 }) => {
    useEffect(() => {
        setTimeout(() => sanitizeReturnUrlAndRedirect(to), delay);
    }, [delay, to]);
    return (
        <IFaceLoader
            title={
                <Trans
                    ns='bo-kit__common'
                    i18nKey="Now you'll be redirected. If nothing happened for a 5 sec, click <Link>here</Link>."
                    components={{
                        Link: <Link href={sanitizeReturnUrl(to) ?? undefined} />,
                    }}
                />
            }
        />
    );
};
